export default __webpack_public_path__ + "static/media/box-inactive.dd4dbc16.svg";